import { render, staticRenderFns } from "./LiveVideoSupport.vue?vue&type=template&id=0bd4af00&"
import script from "./LiveVideoSupport.vue?vue&type=script&lang=js&"
export * from "./LiveVideoSupport.vue?vue&type=script&lang=js&"
import style0 from "./LiveVideoSupport.vue?vue&type=style&index=0&id=0bd4af00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports